import { FileTrackerDataProps } from '../file-tracker-types';
import { useState } from 'react';
import {
  Flex,
  Text,
  Button,
  Icon,
  VStack,
  HStack,
  Input,
} from '@chakra-ui/react';
import { Select } from '@ssar-app/uikit';
import { AiOutlineSearch, AiOutlineLeft } from 'react-icons/ai/index.js';

interface ClientSelectorProps {
  fileTrackerDataCalls?: FileTrackerDataProps;
  setShowGetClient: (val1: boolean) => void;
  setSubscriberCode: (val1: string) => void;
  isSwitchClient: boolean;
  subCodeList: string | string[];
}

export const ClientSelector = (props: ClientSelectorProps) => {
  const {
    fileTrackerDataCalls,
    setShowGetClient,
    setSubscriberCode,
    isSwitchClient,
    subCodeList,
  } = props;
  const [subscriberCodeError, setSubscriberCodeError] = useState<string>('');
  const [tempCode, setTempCode] = useState<string>('');

  const isValidSubscriberCode = (): boolean => {
    if (!tempCode) {
      setSubscriberCodeError('Please provide a valid subscriber code.');
    } else if (!tempCode?.toString()?.trim()) {
      setSubscriberCodeError(
        'Subscriber code should be a valid 7 digit number',
      );
    } else if (!/^\d{7}$/.test(tempCode)) {
      setSubscriberCodeError(
        'Subscriber code should be a number with 7 digits.',
      );
    } else {
      setSubscriberCodeError('');
      return true;
    }
    return false;
  };

  return (
    <Flex
      direction='column'
      bg='white'
      borderRadius='md'
      shadow='md'
      mt='3'
      p='5'
    >
      <VStack justify='center'>
        <VStack>
          <>
            <Text sx={{ fontSize: 'md', fontWeight: 'bold', color: 'black' }}>
              {'Search/Select a Client'}
            </Text>
            <Text sx={{ fontSize: 'sm' }}>
              {'Please provide a subscriber code to view the file tracker data'}
            </Text>
            <Text
              fontSize='sm'
              fontWeight={'semibold'}
              alignSelf={'start'}
              pt={4}
            >
              Client or Subscriber Code
            </Text>
            {Array.isArray(subCodeList) ? (
              <Select
                selectContainerProps={{ width: 350 }}
                placeholder='Select Subscriber Code'
                onChange={(values) => {
                  setTempCode(values as string);
                }}
                options={subCodeList.map((type) => ({
                  label: type,
                  value: type,
                }))}
                optionLabelProps={{ color: 'black' }}
                noOptionsText='No Subscriber code found'
              />
            ) : (
              <Input
                name='subscriberCode'
                w='full'
                required
                onChange={(val) => {
                  setTempCode(val.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.keyCode === 13) {
                    if (isValidSubscriberCode()) {
                      fileTrackerDataCalls?.getClientCode &&
                        fileTrackerDataCalls?.getClientCode(tempCode);
                      setSubscriberCode(tempCode);
                      setShowGetClient(false);
                    }
                  }
                }}
                onBlur={isValidSubscriberCode}
                _focus={{ boxShadow: 'none' }}
                h={8}
                spellCheck={false}
              />
            )}
            <Text color='red.500' textAlign='center'>
              {subscriberCodeError}
            </Text>
          </>
          <HStack justifyContent='center' alignSelf='end' pt={4}>
            <Button
              colorScheme={'gray'}
              variant='outline'
              size='sm'
              sx={{
                _hover: {
                  bg: 'white',
                  color: 'blue.800',
                  borderColor: 'blue.800',
                },
              }}
              onClick={
                isSwitchClient
                  ? () => setShowGetClient(false)
                  : fileTrackerDataCalls?.exitFileTracker
              }
              leftIcon={<Icon as={AiOutlineLeft} />}
            >
              {isSwitchClient ? 'Cancel' : 'Back to Dashboard'}
            </Button>

            <Button
              colorScheme='blue'
              size='md'
              onClick={() => {
                if (isValidSubscriberCode()) {
                  fileTrackerDataCalls?.getClientCode &&
                    fileTrackerDataCalls?.getClientCode(tempCode);
                  setSubscriberCode(tempCode);
                  setShowGetClient(false);
                }
              }}
              h={8}
              leftIcon={<Icon as={AiOutlineSearch} />}
            >
              Search
            </Button>
          </HStack>
        </VStack>
      </VStack>
    </Flex>
  );
};
